import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"
import './rsbutton.css'
import editImg from "../../assets/img/edit-new.png"
const ActionEdit = ({to,onClick, children}) => {
  return (
    <Link
      to={to}
      className={`btn btn-edit`}
      onClick={onClick}
    >
     <img src={editImg} style={{width:20}} /> {children}
    </Link>
  );
};

ActionEdit.propTypes = {
to:PropTypes.string,
onClick: PropTypes.func,
children: PropTypes.string,
};
ActionEdit.defaultProps = {
    to:'#',
    onClick: () => {},
    children:''
  };
export default ActionEdit;
